import { z } from "zod";

/**
 * 에이전트에게 묻기 — 사이트 안의 언어 모델 (harness/API-SPEC.md §13-1, 결정 C85).
 *
 * 모델은 사이트 자료를 **도구**로만 본다: 케이스 검색·케이스 하나·장비 이력·달력·협력사·
 * 오늘의 큐. 도구는 묻는 사람의 세션·스코프로 실행되고, 담당자 이름·연락처는 도구 응답에서
 * 빠진다 — 모델(외부 서비스)에 개인정보를 보내지 않는다.
 */
export const AgentHistoryItemSchema = z.object({
  role: z.enum(["user", "model"]),
  text: z.string().min(1).max(4000),
});

export const AgentAskRequestSchema = z.object({
  question: z.string().trim().min(1).max(2000),
  /** 직전 대화 몇 줄 — 같은 주제로 이어 물을 수 있게. 서버는 저장하지 않는다 */
  history: z.array(AgentHistoryItemSchema).max(12).optional(),
});
export type AgentAskRequest = z.infer<typeof AgentAskRequestSchema>;

export const AgentSourceSchema = z.object({
  label: z.string(),
  hash: z.string(),
});

export const AgentToolCallSchema = z.object({
  name: z.string(),
  args: z.record(z.unknown()),
});

/** 도구가 돌려준 자료 그대로 — 화면이 이걸로 표·목록을 그린다 (C86). 모델은 요약만 한다 */
export const AgentToolResultSchema = z.object({
  name: z.string(),
  args: z.record(z.unknown()),
  result: z.unknown(),
});

export const AgentAskResponseSchema = z.object({
  /** 모델의 요약 1~3줄. 자료에 없는 번호·시리얼은 서버가 걸러낸다 */
  answer: z.string(),
  /** 답을 만들 때 실제로 부른 도구 → 화면 링크. 출처 없는 답은 없다 */
  sources: z.array(AgentSourceSchema),
  tool_calls: z.array(AgentToolCallSchema),
  tool_results: z.array(AgentToolResultSchema),
  /** 모델이 적었지만 도구 자료에 없어 지운 번호·시리얼 */
  unverified: z.array(z.string()),
  model: z.string(),
});
export type AgentAskResponse = z.infer<typeof AgentAskResponseSchema>;
